module.exports = {
	"header": "Vendre sur $t(general::brand)",
	"subHeader": "Services aux encanteurs et caractéristiques",
	"paragraph1": "Nous offrons des solutions pour les encanteurs à travers le monde, quelle que soit leur langue ou leurs besoins spécifiques. Nous avons 10 ans d'expérience dans la vente aux enchères et les systèmes d'encan en temps réel. Nous partageons désormais cette expertise via la plateforme Auctionex.",
	"paragraph2": "Nous vous donnons la possibilité d'atteindre des milliers de nouveaux clients potentiels, d'avoir moins d'articles invendus et d'augmenter vos prix de vente.",
	"dashboard": {
		"header": "Compte d'encanteur et tableau de bord de l'encanteur",
		"paragraph1": "Vous pouvez vous inscrire dès maintenant en tant qu'encanteur et fournir des listes de catalogues gratuits pour les lots de vos enchères, y inclure des descriptions, des photos et en offrir beaucoup plus à vos clients en utilisant le tableau de bord de l'encanteur."
	},
	"premiumAccount": {
		"header": "Compte Premium",
		"paragraph1": "Vous pouvez également vous inscrire à un compte premium pour être en mesure d'utiliser la plateforme Auctionex live et de recevoir des offres en temps réel, peu importe où sont vos clients. Il n'est pas nécessaire que ces derniers se déplacent sur les lieux de votre évènement.",
		"paragraph2": "Vos clients peuvent enchérir de la maison, du bureau ou en déplacement sur ​​leurs appareils mobiles."
	},
	"absenteeBidding": {
		"header": "Ordres d'achat",
		"paragraph1": "Les acheteurs potentiels peuvent programmer des ordres d'achat préalables à la vente aux enchères. Leurs offres seront considérées comme étant l'offre maximale et tout sera géré automatiquement. L'enchère de départ de l'événement sera l'offre la plus élevée parmi les ordres d'achat."
	},
	"liveBidding": {
		"header": "Encan en temps réel (live)",
		"paragraph1": "Permet à vos clients hors du lieu de l'encan de placer des offres en même temps que la vente aux enchères se déroule dans les locaux de votre événement. Les acheteurs peuvent placer l'offre en utilisant leur ordinateur ou appareil mobile."
	},
	"bidderManagement": {
		"header": "Gestion de l'acheteur",
		"paragraph1": "Cette caractéristique du tableau de bord de l'encanteur vous permet de parcourir, d'autoriser ou de désapprouver un acheteur en fonction de son profil. Vous pouvez le faire manuellement ou automatiquement en fonction de vos préférences. Vous pouvez également créer une liste de clients et permettre certaines limites d'offres et d'achats à ce groupe d'acheteurs."
	},
	"photoUpload": {
		"header": "Téléchargement de photos",
		"paragraph1": "En utilisant le tableau de bord de l'encanteur vous pouvez télécharger les photos de vos articles, simplement à partir de votre navigateur web."
	},
	"automatedConsole": {
		"header": "Console d'enchère automatisée",
		"paragraph1": "Vous donne la possibilité de faire fonctionner votre évènement en temps réel sur le pilote automatique, par exemple pour gérer le cas où l'entièreté de vos acheteurs est en ligne."
	},
	"endReport": {
		"header": "Rapport de l'enchère",
		"paragraph1": "Vous pouvez avoir un rapport détaillé pendant et à la fin de chaque enchère contenant diverses statistiques ainsi que des comparaisons."
	},
	"customization": {
		"header": "Personnalisation et intégration",
		"paragraph1": "Vous pouvez personnaliser la console d'encan en temps réel et l'intégrer directement sur votre site web."
	},
	"api": {
		"header": "Intégration de l'API",
		"paragraph1": "Vous pouvez intégrer vos systèmes d'information et de gestion actuels avec notre base de données et ainsi faciliter le processus de publication de vos enchères et l'accès le plus à jour aux informations de vos événements."
	}
}


//////////////////
// WEBPACK FOOTER
// /private/var/folders/n9/yczdnstj3wdc9q5tzm6d45c00000gp/T/maison-encans-auex-website/~/@auex/locales/lib/fr/selling.json5
// module id = 2010
// module chunks = 6